var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapViews',{attrs:{"filterDevicesList":_vm.filterDevicesList,"displayOnly":_vm.displayOnly,"unassigned":_vm.unassigned,"dragOnly":_vm.dragOnly}})}
var staticRenderFns = []

export { render, staticRenderFns }